// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('supplier.articles', {
    controller: 'SupplierArticlesController as vm',
    url: '/articles',
    templateUrl: 'main/supplier/articles/articles.tpl.html',
    data: { pageTitle: 'Articles' },
  });
};

class SupplierArticlesController {
  constructor(supplier) {
    'ngInject';

    this.supplier = supplier;
  }
}

angular
  .module('main.supplier.articles', [])
  .config(config)
  .controller('SupplierArticlesController', SupplierArticlesController);
